export default __webpack_public_path__ + "static/media/Wassily_Kandinsky_Improvisation_sans_titre_35_x_70_cm.dce26ec4.jpg";